import { MailOutlined } from '@ant-design/icons';
import { Button, Tooltip } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';

const ContactButton = () => {
  const { t } = useTranslation();

  const googleFormUrl = 'https://forms.gle/bcnd6apzQruTzy747';

  return (
    <Tooltip title={t('contractButton.tooltipTitle')}>
      <Button
        type="primary"
        shape="circle"
        size="large"
        href={googleFormUrl}
        target="_blank"
        style={{
          position: 'fixed',
          bottom: 24,
          right: 24,
          zIndex: 1000,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
        }}
      >
        <MailOutlined style={{ fontSize: 20 }} />
      </Button>
    </Tooltip>
  );
};

export default ContactButton;
